module.exports = __webpack_public_path__ + "static/media/example2_before.64096231.png";